// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"88":"df55b752334be01e7e4d","195":"9c3d31d09a3617f480c3","243":"307c1cf31df043fbcfea","322":"cc26398eac04afa332cb","556":"9d0971c3cb1418a5d707","595":"26646bacc9920531376e"}[chunkId] + ".bundle.js";
};